// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames not based on template
	if ({353:1,785:1}[chunkId]) return "canvas.09dd9022b53eba88ebad.css";
	if (chunkId === 189) return "editor.8a7c24a8f21553358bb8.css";
	if (chunkId === 35) return "player.9bb5167ac4f4edfbe2ab.css";
	if (chunkId === 231) return "checkout.382863ca8093bdd42ee4.css";
	if (chunkId === 524) return "checkoutEdu.95a6c989f70df9a23da0.css";
	if (chunkId === 559) return "gdrive.99c37209d11cb2d7f8d4.css";
	if (chunkId === 437) return "slack.30c632904b778041d8bd.css";
	// return url for filenames based on template
	return undefined;
};